import { apiCall } from './gqlClient';

const ATHLETECOACHES_QUERY = `
  query athleteCoaches($athleteProfileId: String!) {
    athleteCoaches(athleteProfileId: $athleteProfileId)
    {
      id
			athleteProfileId
			resourceId
			roleOnAthlete
			createdAt
      ...fragments
    }
  }`;

export const athleteCoachesApiCall = async ({athleteProfileId}, fragments = null) => apiCall({ query: ATHLETECOACHES_QUERY, variables: {athleteProfileId}, fragments });

const ASSIGNATHLETECOACH_QUERY = `
  mutation assignAthleteCoach($input: AthleteCoachInput!) {
    assignAthleteCoach(input: $input)
    {
      id
			athleteProfileId
			resourceId
			roleOnAthlete
			createdAt
      ...fragments
    }
  }`;

export const assignAthleteCoachApiCall = async ({input}, fragments = null) => apiCall({ query: ASSIGNATHLETECOACH_QUERY, variables: {input}, fragments });

const UNASSIGNATHLETECOACH_QUERY = `
  mutation unassignAthleteCoach($id: String!) {
    unassignAthleteCoach(id: $id)
    {
      id
			athleteProfileId
			resourceId
			roleOnAthlete
			createdAt
      ...fragments
    }
  }`;

export const unassignAthleteCoachApiCall = async ({id}, fragments = null) => apiCall({ query: UNASSIGNATHLETECOACH_QUERY, variables: {id}, fragments });
